import CommonModal from "PhishingManager/components/Modal";
import { ModalProps } from "PhishingManager/components/Modal/Modal.types";

const FirstWhitelistingModal = ({ open, onClose, onConfirm}: ModalProps) => (<CommonModal
    visible={open}
    confirmText="View Whitelisting Guide"
    cancelText="Close"
    iconType={null}
    modalTitle="Whitelisting Required Before Launch"
    modalContentDesc={[
        "Before creating your first campaign, please ensure that whitelisting has been properly configured in your environment.",
        "Whitelisting is required to allow test emails to be delivered successfully and to ensure tracking assets load correctly. Without this configuration, campaigns may fail or produce incomplete results.",
        "You can proceed without completing this step, but Venza strongly recommends reviewing whitelisting requirements in advance."
    ]}
    onClose={onClose}
    onConfirm={onConfirm}
/>);

export default FirstWhitelistingModal;